import * as O from "fp-ts/Option";
import { PendingData } from "lib/at-data/AsyncData";
import { AssetsHeaderChartState } from "controllers/AssetsHeaderChartController/state";

export const initialState: AssetsHeaderChartState = {
  rootSeries: PendingData(O.none),
};
